import React from 'react';
import BaseIcon from './BaseIcon';

interface ChevronRightIconProps {
  className?: string;
}

const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({ className = "w-5 h-5" }) => (
  <BaseIcon className={className} strokeWidth={2}>
    <path d="m9 18 6-6-6-6"></path>
  </BaseIcon>
);

export default ChevronRightIcon;
